/** @type {any} */
export default window.configuration;